import FloatingVue from 'floating-vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(FloatingVue, {
    themes: {
      tooltip: {
        placement: 'top',
        triggers: ['hover', 'click']
      }
    }
  })
  // nuxtApp.vueApp.directive('tooltip', VTooltip)
  // nuxtApp.vueApp.directive('close-popper', VClosePopper)
  // nuxtApp.vueApp.component('VDropdown', Dropdown)
})